/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliAttendanceDto } from '../../models/amoxcalli-attendance-dto';

export interface ApiAttendanceForParentGet$Plain$Params {
  studentId?: string;
}

export function apiAttendanceForParentGet$Plain(http: HttpClient, rootUrl: string, params?: ApiAttendanceForParentGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AmoxcalliAttendanceDto>>> {
  const rb = new RequestBuilder(rootUrl, apiAttendanceForParentGet$Plain.PATH, 'get');
  if (params) {
    rb.query('studentId', params.studentId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AmoxcalliAttendanceDto>>;
    })
  );
}

apiAttendanceForParentGet$Plain.PATH = '/api/attendance/for-parent';
